import { useEffect, useState } from "react";

import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { Button, Box } from '@mui/material';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import axios from "axios";
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import { Link, useHistory } from 'react-router-dom'
import swal from "sweetalert";
import FormControlLabel from '@mui/material/FormControlLabel';
import { pink } from '@mui/material/colors';
import Checkbox from '@mui/material/Checkbox';

import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';

const Permissions = (props) => {
  const [value, setValue] = useState(0); // This state variable will keep track of the currently selected tab.
  // Handle tab change
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  function TabPanel({ children, value, index }) {
    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`tabpanel-${index}`}
        aria-labelledby={`tab-${index}`}
      >
        {value === index && (
          <div>
            {children}
          </div>
        )}
      </div>
    );
  }


  const history = useHistory();
  const [addPermissionToRole, setAddPermissionToRole] = useState([]);
  const roleId = props.match.params.id;
  const [widgets, setWidgets] = useState('');
  useEffect(() => {
    axios.get(`api/getpermission/?roleId=` + roleId).then(res => {
      if (res.status === 200) {
        const datad = res.data.data;
        setWidgets(datad);
      }
    })

  }, []);



  const hasChecked = (id) => {
    const pId = 'p_' + id;
    return (widgets.hasOwnProperty('permissions') && widgets.permissions.hasOwnProperty(pId)) ? widgets.permissions[pId] : false;
  }

  const handlechnage = (e) => {
    const value = e.target.value;
    const checked = e.target.checked;
    widgets.permissions['p_' + value] = checked;
    if (checked) {
      setAddPermissionToRole([...addPermissionToRole, value]);
    }
    else {
      setAddPermissionToRole(addPermissionToRole.filter((e) => (e !== value)));
    }

  }
  const submitRole = (e) => {
    e.preventDefault();
    console.clear()
    //console.log(widgets.permissions);
    const data = [addPermissionToRole, widgets];
    const permissions = widgets.permissions;
    const selectedPermissions = [];
    for (var permission in permissions) {
      if (permissions.hasOwnProperty(permission)) {
        if (permissions[permission] === true) {
          selectedPermissions.push(permission.replace('p_', ''));
        }
      }
    }
    const obj = {
      "permissions": selectedPermissions,
      "roleId": roleId
    }
    axios.get('/sanctum/csrf-cookie').then(response => {
      axios.post(`api/addpermissiontoroleapi/1`, obj).then(res => {
        if (res.data.status === 200) {
          swal("Success", res.data.message, "success");
          //history.push('/admin/role')
        }
        else {
          swal("Field Are Requried !!", "", "error");
          //setError(res.data.error);
        }

      });
    });

  }

  return (
    <div style={{ margin: '1%', width: '80vw', }}>
      <Box sx={{ color: '#000000', }} style={{ marginTop: '5%' }}>
        <h4 sx={{ m: 2, color: '#000000' }} >
          <Button sx={{
            float: 'right',
            marginTop: '2%',
            ":hover": {
              color: "white"
            }
          }}
            color='success'
            size='small'
            variant='contained'
            component={Link}
            to="/admin/role">
            BAck
          </Button>
        </h4>

        <Card sx={{ width: '80vw', float: 'center' }} >
          <CardContent >
            <Typography component="h1" variant="h5">
              Add Role
            </Typography>
            <Box component="form" onSubmit={submitRole} noValidate sx={{ mt: 3 }}>

              <Box sx={{ color: '#000000', }} style={{ marginTop: '7%' }}>

                <Card sx={{ width: '80vw', float: 'center' }} >
                  <CardContent >
                    <TableContainer >
                      <div>
                        <Tabs
                          value={value}
                          onChange={handleChange}
                          indicatorColor="primary"
                          textColor="primary"
                          centered
                        >
                          <Tab label="Setting permissions" />
                          <Tab label="Abstract permissions" />
                          <Tab label="Exhibition permissions" />
                          <Tab label="Workshop permissions" />
                          <Tab label="Conference permissions" />
                          <Tab label="Conference Affiliation permissions" />
                          {/* <Tab label="MMS permissions" /> */}
                          {/* <Tab label="Tab 3" />
                          <Tab label="Tab 4" /> */}
                        </Tabs>

                        {/* Content for each tab */}

                        {value === 0 && <TabPanel>
                          <Table size="small" aria-label="a dense table">
                            <TableHead>
                              <TableRow sx={{ color: '#FFFFFF' }}>
                                <TableCell >#</TableCell>
                                <TableCell style={{ width: "20%", height: 100 }}> Module Name</TableCell>

                                <TableCell style={{ width: "60%", height: 100 }}>Permissions</TableCell>

                              </TableRow>

                            </TableHead>
                            <TableHead>
                            </TableHead>
                            <TableBody>

                              <TableRow
                                key={1}
                                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>

                                <TableCell component="th" scope="row">
                                  1
                                </TableCell>
                                <TableCell component="th" scope="row">
                                  User Setup
                                </TableCell>
                                <TableCell >

                                  <FormControlLabel required control={<Checkbox color="success" />}
                                    label="View"
                                    color="success"
                                    name="permissions" onChange={handlechnage} value="1" control={<Checkbox checked={hasChecked(1)} />} />


                                  <FormControlLabel required control={<Checkbox />}
                                    label="Add"
                                    name="permissions" onChange={handlechnage} value="2" control={<Checkbox checked={hasChecked(2)} />} />
                                  <FormControlLabel required control={<Checkbox color="secondary" />}
                                    label="Edit"
                                    name="permissions" onChange={handlechnage} value="3" control={<Checkbox checked={hasChecked(3)} />} />
                                  <FormControlLabel required control={<Checkbox
                                    sx={{
                                      '&.Mui-checked': {
                                        color: pink[600],
                                      },
                                    }} />}
                                    label="Delete"
                                    name="permissions" onChange={handlechnage} value="4" control={<Checkbox checked={hasChecked(4)} />} />
                                </TableCell>

                              </TableRow>
                              <TableRow
                                key={2}
                                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>

                                <TableCell component="th" scope="row">
                                  2
                                </TableCell>
                                <TableCell component="th" scope="row">
                                  Role Setup
                                </TableCell>
                                <TableCell >

                                  <FormControlLabel required control={<Checkbox color="success" />}
                                    label="View"
                                    color="success"
                                    name="permissions" onChange={handlechnage} value="5" control={<Checkbox checked={hasChecked(5)} />} />
                                  <FormControlLabel required control={<Checkbox />}
                                    label="Add"
                                    name="permissions" onChange={handlechnage} value="6" control={<Checkbox checked={hasChecked(6)} />} />
                                  <FormControlLabel required control={<Checkbox color="secondary" />}
                                    label="Edit"
                                    name="permissions" onChange={handlechnage} value="7" control={<Checkbox checked={hasChecked(7)} />} />
                                  <FormControlLabel required control={<Checkbox sx={{

                                    '&.Mui-checked': {
                                      color: pink[600],
                                    },
                                  }} />}
                                    label="Delete"
                                    name="permissions" onChange={handlechnage} value="8" control={<Checkbox checked={hasChecked(8)} />} />
                                </TableCell>

                              </TableRow>
                              <TableRow
                                key={3}
                                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>

                                <TableCell component="th" scope="row">
                                  3
                                </TableCell>
                                <TableCell component="th" scope="row">
                                  Custom Field
                                </TableCell>
                                <TableCell >

                                  <FormControlLabel required control={<Checkbox color="success" />}
                                    label="View"
                                    color="success"
                                    name="permissions" onChange={handlechnage} value="91" control={<Checkbox checked={hasChecked(91)} />} />
                                  <FormControlLabel required control={<Checkbox />}
                                    label="Add"
                                    name="permissions" onChange={handlechnage} value="92" control={<Checkbox checked={hasChecked(92)} />} />
                                  <FormControlLabel required control={<Checkbox color="secondary" />}
                                    label="Edit"
                                    name="permissions" onChange={handlechnage} value="93" control={<Checkbox checked={hasChecked(93)} />} />
                                  <FormControlLabel required control={<Checkbox sx={{

                                    '&.Mui-checked': {
                                      color: pink[600],
                                    },
                                  }} />}
                                    label="Delete"
                                    name="permissions" onChange={handlechnage} value="94" control={<Checkbox checked={hasChecked(94)} />} />
                                </TableCell>

                              </TableRow>

                              <TableRow
                                key={4}
                                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                <TableCell component="th" scope="row">
                                  4
                                </TableCell>
                                <TableCell component="th" scope="row">
                                  Event Smtp Setting
                                </TableCell>
                                <TableCell >
                                  <FormControlLabel required control={<Checkbox color="success" />}
                                    label="Control"
                                    color="success"
                                    name="permissions" onChange={handlechnage} value="51" checked={hasChecked(51)} />
                                </TableCell>
                              </TableRow>
                              <TableRow
                                key={5}
                                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                <TableCell component="th" scope="row">
                                  5
                                </TableCell>
                                <TableCell component="th" scope="row">
                                  Payment Setting
                                </TableCell>
                                <TableCell >
                                  <FormControlLabel required control={<Checkbox color="success" />}
                                    label="Control"
                                    color="success"
                                    name="permissions" onChange={handlechnage} value="95" checked={hasChecked(95)} />
                                </TableCell>
                              </TableRow>
                              <TableRow
                                key={6}
                                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                <TableCell component="th" scope="row">
                                  6
                                </TableCell>
                                <TableCell component="th" scope="row">
                                  Email Template Setting
                                </TableCell>
                                <TableCell >
                                  <FormControlLabel required control={<Checkbox color="success" />}
                                    label="View"
                                    color="success"
                                    name="permissions" onChange={handlechnage} value="192" checked={hasChecked(192)} />
                                </TableCell>
                              </TableRow>


                            </TableBody>
                          </Table>
                        </TabPanel>}
                        {value === 1 && <TabPanel>
                          <Table size="small" aria-label="a dense table">
                            <TableHead>
                              <TableRow sx={{ color: '#FFFFFF' }}>
                                <TableCell >#</TableCell>
                                <TableCell style={{ width: "20%", height: 100 }}> Module Name</TableCell>

                                <TableCell style={{ width: "60%", height: 100 }}>Permissions</TableCell>

                              </TableRow>

                            </TableHead>
                            <TableHead>
                            </TableHead>
                            <TableBody>

                              {/* <TableRow
                                key={1}
                                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>

                                <TableCell component="th" scope="row">
                                  1
                                </TableCell>
                                <TableCell component="th" scope="row">
                                  User Setup
                                </TableCell>
                                <TableCell >
                                 
                                  <FormControlLabel required control={<Checkbox color="success" />}
                                    label="View"
                                    color="success"
                                    name="permissions" onChange={handlechnage} value="1" control={<Checkbox checked={hasChecked(1)} />} />


                                  <FormControlLabel required control={<Checkbox />}
                                    label="Add"
                                    name="permissions" onChange={handlechnage} value="2" control={<Checkbox checked={hasChecked(2)} />} />
                                  <FormControlLabel required control={<Checkbox color="secondary" />}
                                    label="Edit"
                                    name="permissions" onChange={handlechnage} value="3" control={<Checkbox checked={hasChecked(3)} />} />
                                  <FormControlLabel required control={<Checkbox
                                    sx={{
                                      '&.Mui-checked': {
                                        color: pink[600],
                                      },
                                    }} />}
                                    label="Delete"
                                    name="permissions" onChange={handlechnage} value="4" control={<Checkbox checked={hasChecked(4)} />} />
                                </TableCell>

                              </TableRow>
                              <TableRow
                                key={2}
                                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>

                                <TableCell component="th" scope="row">
                                  2
                                </TableCell>
                                <TableCell component="th" scope="row">
                                  Role Setup
                                </TableCell>
                                <TableCell >

                                  <FormControlLabel required control={<Checkbox color="success" />}
                                    label="View"
                                    color="success"
                                    name="permissions" onChange={handlechnage} value="5" control={<Checkbox checked={hasChecked(5)} />} />
                                  <FormControlLabel required control={<Checkbox />}
                                    label="Add"
                                    name="permissions" onChange={handlechnage} value="6" control={<Checkbox checked={hasChecked(6)} />} />
                                  <FormControlLabel required control={<Checkbox color="secondary" />}
                                    label="Edit"
                                    name="permissions" onChange={handlechnage} value="7" control={<Checkbox checked={hasChecked(7)} />} />
                                  <FormControlLabel required control={<Checkbox sx={{

                                    '&.Mui-checked': {
                                      color: pink[600],
                                    },
                                  }} />}
                                    label="Delete"
                                    name="permissions" onChange={handlechnage} value="8" control={<Checkbox checked={hasChecked(8)} />} />
                                </TableCell>

                              </TableRow>
                              <TableRow
                                key={3}
                                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>

                                <TableCell component="th" scope="row">
                                  3
                                </TableCell>
                                <TableCell component="th" scope="row">
                                  Custom Field
                                </TableCell>
                                <TableCell >

                                  <FormControlLabel required control={<Checkbox color="success" />}
                                    label="View"
                                    color="success"
                                    name="permissions" onChange={handlechnage} value="91" control={<Checkbox checked={hasChecked(91)} />} />
                                  <FormControlLabel required control={<Checkbox />}
                                    label="Add"
                                    name="permissions" onChange={handlechnage} value="92" control={<Checkbox checked={hasChecked(92)} />} />
                                  <FormControlLabel required control={<Checkbox color="secondary" />}
                                    label="Edit"
                                    name="permissions" onChange={handlechnage} value="93" control={<Checkbox checked={hasChecked(93)} />} />
                                  <FormControlLabel required control={<Checkbox sx={{

                                    '&.Mui-checked': {
                                      color: pink[600],
                                    },
                                  }} />}
                                    label="Delete"
                                    name="permissions" onChange={handlechnage} value="94" control={<Checkbox checked={hasChecked(94)} />} />
                                </TableCell>

                              </TableRow> */}


                              <TableRow
                                key={1}
                                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>

                                <TableCell component="th" scope="row">
                                  1
                                </TableCell>
                                <TableCell component="th" scope="row">
                                  Abstract Category
                                </TableCell>
                                <TableCell >
                                  <FormControlLabel required control={<Checkbox color="success" />}
                                    label="View"
                                    color="success"
                                    name="permissions" onChange={handlechnage} value="13" control={<Checkbox checked={hasChecked(13)} />} />
                                  <FormControlLabel required control={<Checkbox />}
                                    label="Add"
                                    name="permissions" onChange={handlechnage} value="14" control={<Checkbox checked={hasChecked(14)} />} />
                                  <FormControlLabel required control={<Checkbox color="secondary" />}
                                    label="Edit"
                                    name="permissions" onChange={handlechnage} value="15" control={<Checkbox checked={hasChecked(15)} />} />
                                  <FormControlLabel required control={<Checkbox sx={{

                                    '&.Mui-checked': {
                                      color: pink[600],
                                    },
                                  }} />}
                                    label="Delete"
                                    name="permissions" onChange={handlechnage} value="16" control={<Checkbox checked={hasChecked(16)} />} />
                                </TableCell>
                              </TableRow>
                              <TableRow
                                key={2}
                                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                <TableCell component="th" scope="row">
                                  2
                                </TableCell>
                                <TableCell component="th" scope="row">
                                  Abstract Approve Article
                                </TableCell>
                                <TableCell >


                                  <FormControlLabel required control={<Checkbox color="success" />}
                                    label="View"
                                    color="success"
                                    name="permissions" onChange={handlechnage} value="17"
                                    control={<Checkbox checked={hasChecked(17)} />}

                                  />

                                  <FormControlLabel required control={<Checkbox />}
                                    label="Add"
                                    name="permissions" onChange={handlechnage} value="18"
                                    control={<Checkbox checked={hasChecked(18)} />} />

                                  <FormControlLabel required control={<Checkbox color="secondary" />}
                                    label="Edit"
                                    name="permissions" onChange={handlechnage} value="19" checked={hasChecked(19)} />
                                  <FormControlLabel required control={<Checkbox sx={{

                                    '&.Mui-checked': {
                                      color: pink[600],
                                    },
                                  }} />}
                                    label="Delete"
                                    name="permissions" onChange={handlechnage} value="20" checked={hasChecked(20)} />
                                </TableCell>
                              </TableRow>

                              <TableRow
                                key={3}
                                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                <TableCell component="th" scope="row">
                                  3
                                </TableCell>
                                <TableCell component="th" scope="row">
                                  Abstract Pending Article
                                </TableCell>
                                <TableCell >
                                  <FormControlLabel required control={<Checkbox color="success" />}
                                    label="View"
                                    color="success"
                                    name="permissions" onChange={handlechnage} value="21" checked={hasChecked(21)} />
                                  <FormControlLabel required control={<Checkbox />}
                                    label="Add"
                                    name="permissions" onChange={handlechnage} value="22" checked={hasChecked(22)} />
                                  <FormControlLabel required control={<Checkbox color="secondary" />}
                                    label="Edit"
                                    name="permissions" onChange={handlechnage} value="23" checked={hasChecked(23)} />
                                  <FormControlLabel required control={<Checkbox sx={{

                                    '&.Mui-checked': {
                                      color: pink[600],
                                    },
                                  }} />}
                                    label="Delete"
                                    name="permissions" onChange={handlechnage} value="24" checked={hasChecked(24)} />
                                </TableCell>
                              </TableRow>

                              <TableRow
                                key={4}
                                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                <TableCell component="th" scope="row">
                                  4
                                </TableCell>
                                <TableCell component="th" scope="row">
                                  Abstract Reject Article
                                </TableCell>
                                <TableCell >
                                  <FormControlLabel required control={<Checkbox color="success" />}
                                    label="View"
                                    color="success"
                                    name="permissions" onChange={handlechnage} value="25" checked={hasChecked(25)} />
                                  <FormControlLabel required control={<Checkbox />}
                                    label="Add"
                                    name="permissions" onChange={handlechnage} value="26" checked={hasChecked(26)} />
                                  <FormControlLabel required control={<Checkbox color="secondary" />}
                                    label="Edit"
                                    name="permissions" onChange={handlechnage} value="27" checked={hasChecked(27)} />
                                  <FormControlLabel required control={<Checkbox sx={{

                                    '&.Mui-checked': {
                                      color: pink[600],
                                    },
                                  }} />}
                                    label="Delete"
                                    name="permissions" onChange={handlechnage} value="28" checked={hasChecked(28)} />
                                </TableCell>
                              </TableRow>

                              <TableRow
                                key={5}
                                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                <TableCell component="th" scope="row">
                                  5
                                </TableCell>
                                <TableCell component="th" scope="row">
                                  Abstract Requirements Article
                                </TableCell>
                                <TableCell >
                                  <FormControlLabel required control={<Checkbox color="success" />}
                                    label="View"
                                    color="success"
                                    name="permissions" onChange={handlechnage} value="29" checked={hasChecked(29)} />
                                  <FormControlLabel required control={<Checkbox />}
                                    label="Add"
                                    name="permissions" onChange={handlechnage} value="30" checked={hasChecked(30)} />
                                  <FormControlLabel required control={<Checkbox color="secondary" />}
                                    label="Edit"
                                    name="permissions" onChange={handlechnage} value="31" checked={hasChecked(31)} />
                                  <FormControlLabel required control={<Checkbox sx={{

                                    '&.Mui-checked': {
                                      color: pink[600],
                                    },
                                  }} />}
                                    label="Delete"
                                    name="permissions" onChange={handlechnage} value="32" checked={hasChecked(32)} />
                                </TableCell>
                              </TableRow>

                              <TableRow
                                key={6}
                                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                <TableCell component="th" scope="row">
                                  6
                                </TableCell>
                                <TableCell component="th" scope="row">
                                  Abstract Comments Article
                                </TableCell>
                                <TableCell >
                                  <FormControlLabel required control={<Checkbox color="success" />}
                                    label="View"
                                    color="success"
                                    name="permissions" onChange={handlechnage} value="33" checked={hasChecked(33)} />
                                  <FormControlLabel required control={<Checkbox />}
                                    label="Add"
                                    name="permissions" onChange={handlechnage} value="34" checked={hasChecked(34)} />
                                  <FormControlLabel required control={<Checkbox color="secondary" />}
                                    label="Edit"
                                    name="permissions" onChange={handlechnage} value="35" checked={hasChecked(35)} />
                                  <FormControlLabel required control={<Checkbox sx={{

                                    '&.Mui-checked': {
                                      color: pink[600],
                                    },
                                  }} />}
                                    label="Delete"
                                    name="permissions" onChange={handlechnage} value="36" checked={hasChecked(36)} />
                                </TableCell>
                              </TableRow>

                              <TableRow
                                key={7}
                                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                <TableCell component="th" scope="row">
                                  7
                                </TableCell>
                                <TableCell component="th" scope="row">
                                  Abstract Reviewer Article
                                </TableCell>
                                <TableCell >
                                  <FormControlLabel required control={<Checkbox color="success" />}
                                    label="View"
                                    color="success"
                                    name="permissions" onChange={handlechnage} value="37" checked={hasChecked(37)} />
                                  <FormControlLabel required control={<Checkbox />}
                                    label="Add"
                                    name="permissions" onChange={handlechnage} value="38" checked={hasChecked(38)} />
                                  <FormControlLabel required control={<Checkbox color="secondary" />}
                                    label="Edit"
                                    name="permissions" onChange={handlechnage} value="39" checked={hasChecked(39)} />
                                  <FormControlLabel required control={<Checkbox sx={{

                                    '&.Mui-checked': {
                                      color: pink[600],
                                    },
                                  }} />}
                                    label="Delete"
                                    name="permissions" onChange={handlechnage} value="40" checked={hasChecked(40)} />
                                </TableCell>
                              </TableRow>

                              <TableRow
                                key={8}
                                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                <TableCell component="th" scope="row">
                                  8
                                </TableCell>
                                <TableCell component="th" scope="row">
                                  Abstract Author Article
                                </TableCell>
                                <TableCell >
                                  <FormControlLabel required control={<Checkbox color="success" />}
                                    label="View"
                                    color="success"
                                    name="permissions" onChange={handlechnage} value="41" checked={hasChecked(41)} />
                                  <FormControlLabel required control={<Checkbox />}
                                    label="Add"
                                    name="permissions" onChange={handlechnage} value="42" checked={hasChecked(42)} />
                                  <FormControlLabel required control={<Checkbox color="secondary" />}
                                    label="Edit"
                                    name="permissions" onChange={handlechnage} value="43" checked={hasChecked(43)} />
                                  <FormControlLabel required control={<Checkbox sx={{

                                    '&.Mui-checked': {
                                      color: pink[600],
                                    },
                                  }} />}
                                    label="Delete"
                                    name="permissions" onChange={handlechnage} value="44" checked={hasChecked(44)} />
                                </TableCell>
                              </TableRow>
                              <TableRow
                                key={9}
                                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                <TableCell component="th" scope="row">
                                  9
                                </TableCell>
                                <TableCell component="th" scope="row">
                                  Abstract Instruction
                                </TableCell>
                                <TableCell >
                                  <FormControlLabel required control={<Checkbox color="success" />}
                                    label="View"
                                    color="success"
                                    name="permissions" onChange={handlechnage} value="45" checked={hasChecked(45)} />
                                  <FormControlLabel required control={<Checkbox />}
                                    label="Add"
                                    name="permissions" onChange={handlechnage} value="46" checked={hasChecked(46)} />
                                  <FormControlLabel required control={<Checkbox color="secondary" />}
                                    label="Edit"
                                    name="permissions" onChange={handlechnage} value="47" checked={hasChecked(47)} />
                                  <FormControlLabel required control={<Checkbox sx={{

                                    '&.Mui-checked': {
                                      color: pink[600],
                                    },
                                  }} />}
                                    label="Delete"
                                    name="permissions" onChange={handlechnage} value="48" checked={hasChecked(48)} />
                                </TableCell>
                              </TableRow>

                              <TableRow
                                key={10}
                                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                <TableCell component="th" scope="row">
                                  10
                                </TableCell>
                                <TableCell component="th" scope="row">
                                  Abstract Setting
                                </TableCell>
                                <TableCell >
                                  <FormControlLabel required control={<Checkbox color="success" />}
                                    label="View"
                                    color="success"
                                    name="permissions" onChange={handlechnage} value="49" checked={hasChecked(49)} />



                                </TableCell>
                              </TableRow>
                              <TableRow
                                key={11}
                                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                <TableCell component="th" scope="row">
                                  11
                                </TableCell>
                                <TableCell component="th" scope="row">
                                  Abstract Review Status
                                </TableCell>
                                <TableCell >
                                  <FormControlLabel required control={<Checkbox color="success" />}
                                    label="View"
                                    color="success"
                                    name="permissions" onChange={handlechnage} value="50" checked={hasChecked(50)} />
                                </TableCell>
                              </TableRow>

                              {/* <TableRow
                                key={12}
                                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                <TableCell component="th" scope="row">
                                  12
                                </TableCell>
                                <TableCell component="th" scope="row">
                                  Event Smtp Setting
                                </TableCell>
                                <TableCell >
                                  <FormControlLabel required control={<Checkbox color="success" />}
                                    label="Control"
                                    color="success"
                                    name="permissions" onChange={handlechnage} value="51" checked={hasChecked(51)} />
                                </TableCell>
                              </TableRow> */}

                              <TableRow
                                key={12}
                                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                <TableCell component="th" scope="row">
                                  12
                                </TableCell>
                                <TableCell component="th" scope="row">
                                  Abstract Event Add Questions
                                </TableCell>
                                <TableCell >
                                  <FormControlLabel required control={<Checkbox color="success" />}
                                    label="Add / View"
                                    color="success"
                                    name="permissions" onChange={handlechnage} value="52" checked={hasChecked(52)} />
                                </TableCell>
                              </TableRow>

                              <TableRow
                                key={13}
                                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                <TableCell component="th" scope="row">
                                  15
                                </TableCell>
                                <TableCell component="th" scope="row">
                                  Abstract Score
                                </TableCell>
                                <TableCell >
                                  <FormControlLabel required control={<Checkbox color="success" />}
                                    label="View"
                                    color="success"
                                    name="permissions" onChange={handlechnage} value="194" checked={hasChecked(194)} />
                                </TableCell>
                              </TableRow>

                            </TableBody>
                          </Table>
                        </TabPanel>}
                        {value === 2 && <TabPanel>
                          <Table size="small" aria-label="a dense table">
                            <TableHead>
                              <TableRow sx={{ color: '#FFFFFF' }}>
                                <TableCell >#</TableCell>
                                <TableCell style={{ width: "20%", height: 100 }}> Module Name</TableCell>

                                <TableCell style={{ width: "60%", height: 100 }}>Permissions</TableCell>

                              </TableRow>

                            </TableHead>
                            <TableHead>
                            </TableHead>
                            <TableBody>

                              <TableRow
                                key={1}
                                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                <TableCell component="th" scope="row">
                                  1
                                </TableCell>
                                <TableCell component="th" scope="row">
                                  Booth Categories
                                </TableCell>
                                <TableCell >
                                  <FormControlLabel required control={<Checkbox color="success" />}
                                    label="View"
                                    color="success"
                                    name="permissions" onChange={handlechnage} value="53" control={<Checkbox checked={hasChecked(53)} />} />
                                  <FormControlLabel required control={<Checkbox />}
                                    label="Add"
                                    name="permissions" onChange={handlechnage} value="54" control={<Checkbox checked={hasChecked(54)} />} />
                                  <FormControlLabel required control={<Checkbox color="secondary" />}
                                    label="Edit"
                                    name="permissions" onChange={handlechnage} value="55" control={<Checkbox checked={hasChecked(55)} />} />
                                  <FormControlLabel required control={<Checkbox
                                    sx={{
                                      '&.Mui-checked': {
                                        color: pink[600],
                                      },
                                    }} />}
                                    label="Delete"
                                    name="permissions" onChange={handlechnage} value="56" control={<Checkbox checked={hasChecked(56)} />} />
                                </TableCell>
                              </TableRow>

                              <TableRow
                                key={2}
                                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                <TableCell component="th" scope="row">
                                  2
                                </TableCell>
                                <TableCell component="th" scope="row">
                                  Booths
                                </TableCell>
                                <TableCell >
                                  <FormControlLabel required control={<Checkbox color="success" />}
                                    label="View"
                                    color="success"
                                    name="permissions" onChange={handlechnage} value="57" control={<Checkbox checked={hasChecked(57)} />} />
                                  <FormControlLabel required control={<Checkbox />}
                                    label="Add"
                                    name="permissions" onChange={handlechnage} value="58" control={<Checkbox checked={hasChecked(58)} />} />
                                  <FormControlLabel required control={<Checkbox color="secondary" />}
                                    label="Edit"
                                    name="permissions" onChange={handlechnage} value="59" control={<Checkbox checked={hasChecked(59)} />} />
                                  <FormControlLabel required control={<Checkbox sx={{

                                    '&.Mui-checked': {
                                      color: pink[600],
                                    },
                                  }} />}
                                    label="Delete"
                                    name="permissions" onChange={handlechnage} value="60" control={<Checkbox checked={hasChecked(60)} />} />
                                </TableCell>
                              </TableRow>

                              <TableRow
                                key={3}
                                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>

                                <TableCell component="th" scope="row">
                                  3
                                </TableCell>
                                <TableCell component="th" scope="row">
                                  Booking
                                </TableCell>
                                <TableCell >
                                  <FormControlLabel required control={<Checkbox color="success" />}
                                    label="View"
                                    color="success"
                                    name="permissions" onChange={handlechnage} value="61" control={<Checkbox checked={hasChecked(61)} />} />
                                  <FormControlLabel required control={<Checkbox />}
                                    label="Add"
                                    name="permissions" onChange={handlechnage} value="62" control={<Checkbox checked={hasChecked(62)} />} />
                                  <FormControlLabel required control={<Checkbox color="secondary" />}
                                    label="Edit"
                                    name="permissions" onChange={handlechnage} value="63" control={<Checkbox checked={hasChecked(63)} />} />
                                  <FormControlLabel required control={<Checkbox sx={{

                                    '&.Mui-checked': {
                                      color: pink[600],
                                    },
                                  }} />}
                                    label="Delete"
                                    name="permissions" onChange={handlechnage} value="64" control={<Checkbox checked={hasChecked(64)} />} />
                                </TableCell>
                              </TableRow>
                              <TableRow
                                key={4}
                                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                <TableCell component="th" scope="row">
                                  4
                                </TableCell>
                                <TableCell component="th" scope="row">
                                  Exhibitior Categories
                                </TableCell>
                                <TableCell >
                                  <FormControlLabel required control={<Checkbox color="success" />}
                                    label="View"
                                    color="success"
                                    name="permissions" onChange={handlechnage} value="65"
                                    control={<Checkbox checked={hasChecked(65)} />} />
                                  <FormControlLabel required control={<Checkbox />}
                                    label="Add"
                                    name="permissions" onChange={handlechnage} value="66"
                                    control={<Checkbox checked={hasChecked(66)} />} />
                                  <FormControlLabel required control={<Checkbox color="secondary" />}
                                    label="Edit"
                                    name="permissions" onChange={handlechnage} value="67" checked={hasChecked(67)} />
                                  <FormControlLabel required control={<Checkbox sx={{

                                    '&.Mui-checked': {
                                      color: pink[600],
                                    },
                                  }} />}
                                    label="Delete"
                                    name="permissions" onChange={handlechnage} value="68" checked={hasChecked(68)} />
                                </TableCell>
                              </TableRow>

                              <TableRow
                                key={5}
                                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                <TableCell component="th" scope="row">
                                  5
                                </TableCell>
                                <TableCell component="th" scope="row">
                                  Exhibitor
                                </TableCell>
                                <TableCell >
                                  <FormControlLabel required control={<Checkbox color="success" />}
                                    label="View"
                                    color="success"
                                    name="permissions" onChange={handlechnage} value="69" checked={hasChecked(69)} />
                                  <FormControlLabel required control={<Checkbox />}
                                    label="Add"
                                    name="permissions" onChange={handlechnage} value="70" checked={hasChecked(70)} />
                                  <FormControlLabel required control={<Checkbox color="secondary" />}
                                    label="Edit"
                                    name="permissions" onChange={handlechnage} value="71" checked={hasChecked(71)} />
                                  <FormControlLabel required control={<Checkbox sx={{

                                    '&.Mui-checked': {
                                      color: pink[600],
                                    },
                                  }} />}
                                    label="Delete"
                                    name="permissions" onChange={handlechnage} value="72" checked={hasChecked(72)} />
                                </TableCell>
                              </TableRow>

                              <TableRow
                                key={6}
                                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                <TableCell component="th" scope="row">
                                  6
                                </TableCell>
                                <TableCell component="th" scope="row">
                                  Product And Services
                                </TableCell>
                                <TableCell >
                                  <FormControlLabel required control={<Checkbox color="success" />}
                                    label="View"
                                    color="success"
                                    name="permissions" onChange={handlechnage} value="73" checked={hasChecked(73)} />
                                  <FormControlLabel required control={<Checkbox />}
                                    label="Add"
                                    name="permissions" onChange={handlechnage} value="74" checked={hasChecked(74)} />
                                  <FormControlLabel required control={<Checkbox color="secondary" />}
                                    label="Edit"
                                    name="permissions" onChange={handlechnage} value="75" checked={hasChecked(75)} />
                                  <FormControlLabel required control={<Checkbox sx={{

                                    '&.Mui-checked': {
                                      color: pink[600],
                                    },
                                  }} />}
                                    label="Delete"
                                    name="permissions" onChange={handlechnage} value="76" checked={hasChecked(76)} />
                                </TableCell>
                              </TableRow>

                              <TableRow
                                key={7}
                                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                <TableCell component="th" scope="row">
                                  7
                                </TableCell>
                                <TableCell component="th" scope="row">
                                  Nature Of Business
                                </TableCell>
                                <TableCell >
                                  <FormControlLabel required control={<Checkbox color="success" />}
                                    label="View"
                                    color="success"
                                    name="permissions" onChange={handlechnage} value="77" checked={hasChecked(77)} />
                                  <FormControlLabel required control={<Checkbox />}
                                    label="Add"
                                    name="permissions" onChange={handlechnage} value="78" checked={hasChecked(78)} />
                                  <FormControlLabel required control={<Checkbox color="secondary" />}
                                    label="Edit"
                                    name="permissions" onChange={handlechnage} value="79" checked={hasChecked(79)} />
                                  <FormControlLabel required control={<Checkbox sx={{

                                    '&.Mui-checked': {
                                      color: pink[600],
                                    },
                                  }} />}
                                    label="Delete"
                                    name="permissions" onChange={handlechnage} value="80" checked={hasChecked(80)} />
                                </TableCell>
                              </TableRow>

                              <TableRow
                                key={8}
                                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                <TableCell component="th" scope="row">
                                  8
                                </TableCell>
                                <TableCell component="th" scope="row">
                                  Guest Badge Design
                                </TableCell>
                                <TableCell >
                                  <FormControlLabel required control={<Checkbox color="success" />}
                                    label="View"
                                    color="success"
                                    name="permissions" onChange={handlechnage} value="81" checked={hasChecked(81)} />
                                  <FormControlLabel required control={<Checkbox />}
                                    label="Add"
                                    name="permissions" onChange={handlechnage} value="82" checked={hasChecked(82)} />
                                  <FormControlLabel required control={<Checkbox color="secondary" />}
                                    label="Edit"
                                    name="permissions" onChange={handlechnage} value="83" checked={hasChecked(83)} />
                                  <FormControlLabel required control={<Checkbox sx={{

                                    '&.Mui-checked': {
                                      color: pink[600],
                                    },
                                  }} />}
                                    label="Delete"
                                    name="permissions" onChange={handlechnage} value="84" checked={hasChecked(84)} />
                                </TableCell>
                              </TableRow>

                              <TableRow
                                key={9}
                                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                <TableCell component="th" scope="row">
                                  9
                                </TableCell>
                                <TableCell component="th" scope="row">
                                  Visitor's
                                </TableCell>
                                <TableCell >
                                  <FormControlLabel required control={<Checkbox color="success" />}
                                    label="View"
                                    color="success"
                                    name="permissions" onChange={handlechnage} value="85" checked={hasChecked(85)} />

                                </TableCell>
                              </TableRow>

                              <TableRow
                                key={10}
                                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                <TableCell component="th" scope="row">
                                  10
                                </TableCell>
                                <TableCell component="th" scope="row">
                                  Register Guest
                                </TableCell>
                                <TableCell >
                                  <FormControlLabel required control={<Checkbox color="success" />}
                                    label="View"
                                    color="success"
                                    name="permissions" onChange={handlechnage} value="86" checked={hasChecked(86)} />
                                  <FormControlLabel required control={<Checkbox />}
                                    label="print"
                                    name="permissions" onChange={handlechnage} value="87" checked={hasChecked(87)} />
                                  <FormControlLabel required control={<Checkbox color="secondary" />}
                                    label="Edit"
                                    name="permissions" onChange={handlechnage} value="88" checked={hasChecked(88)} />
                                  <FormControlLabel required control={<Checkbox sx={{

                                    '&.Mui-checked': {
                                      color: pink[600],
                                    },
                                  }} />}
                                    label="Delete"
                                    name="permissions" onChange={handlechnage} value="89" checked={hasChecked(89)} />
                                </TableCell>
                              </TableRow>
                              <TableRow
                                key={11}
                                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                <TableCell component="th" scope="row">
                                  11
                                </TableCell>
                                <TableCell component="th" scope="row">
                                  Self Scan Qr Code
                                </TableCell>
                                <TableCell >
                                  <FormControlLabel required control={<Checkbox color="success" />}
                                    label="View"
                                    color="success"
                                    name="permissions" onChange={handlechnage} value="90" checked={hasChecked(90)} />

                                </TableCell>
                              </TableRow>
                              {/* nxet value start from 96 becz 91 to 95 used for custom field on on the top */}


                            </TableBody>
                          </Table>
                        </TabPanel>}

                        {value === 3 && <TabPanel>
                          <Table size="small" aria-label="a dense table">
                            <TableHead>
                              <TableRow sx={{ color: '#FFFFFF' }}>
                                <TableCell >#</TableCell>
                                <TableCell style={{ width: "20%", height: 100 }}> Module Name</TableCell>

                                <TableCell style={{ width: "60%", height: 100 }}>Permissions</TableCell>

                              </TableRow>

                            </TableHead>
                            <TableHead>
                            </TableHead>
                            <TableBody>

                              <TableRow
                                key={1}
                                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                <TableCell component="th" scope="row">
                                  1
                                </TableCell>
                                <TableCell component="th" scope="row">
                                  Workshop Categories
                                </TableCell>
                                <TableCell >
                                  <FormControlLabel required control={<Checkbox color="success" />}
                                    label="View"
                                    color="success"
                                    name="permissions" onChange={handlechnage} value="96" control={<Checkbox checked={hasChecked(96)} />} />
                                  <FormControlLabel required control={<Checkbox />}
                                    label="Add"
                                    name="permissions" onChange={handlechnage} value="97" control={<Checkbox checked={hasChecked(97)} />} />
                                  <FormControlLabel required control={<Checkbox color="secondary" />}
                                    label="Edit"
                                    name="permissions" onChange={handlechnage} value="98" control={<Checkbox checked={hasChecked(98)} />} />
                                  <FormControlLabel required control={<Checkbox
                                    sx={{
                                      '&.Mui-checked': {
                                        color: pink[600],
                                      },
                                    }} />}
                                    label="Delete"
                                    name="permissions" onChange={handlechnage} value="99" control={<Checkbox checked={hasChecked(99)} />} />
                                </TableCell>
                              </TableRow>

                              <TableRow
                                key={2}
                                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                <TableCell component="th" scope="row">
                                  2
                                </TableCell>
                                <TableCell component="th" scope="row">
                                  Manage Workshop
                                </TableCell>
                                <TableCell >
                                  <FormControlLabel required control={<Checkbox color="success" />}
                                    label="View"
                                    color="success"
                                    name="permissions" onChange={handlechnage} value="100" control={<Checkbox checked={hasChecked(100)} />} />
                                  <FormControlLabel required control={<Checkbox />}
                                    label="Add"
                                    name="permissions" onChange={handlechnage} value="101" control={<Checkbox checked={hasChecked(101)} />} />
                                  <FormControlLabel required control={<Checkbox color="secondary" />}
                                    label="Edit"
                                    name="permissions" onChange={handlechnage} value="102" control={<Checkbox checked={hasChecked(102)} />} />

                                  <FormControlLabel required control={<Checkbox color="secondary" />}
                                    label="Workshop URL"
                                    name="permissions" onChange={handlechnage} value="140" control={<Checkbox checked={hasChecked(140)} />} />

                                  <FormControlLabel required control={<Checkbox sx={{

                                    '&.Mui-checked': {
                                      color: pink[600],
                                    },
                                  }} />}
                                    label="Delete"
                                    name="permissions" onChange={handlechnage} value="103" control={<Checkbox checked={hasChecked(103)} />} />
                                </TableCell>
                              </TableRow>

                              <TableRow
                                key={3}
                                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>

                                <TableCell component="th" scope="row">
                                  3
                                </TableCell>
                                <TableCell component="th" scope="row">
                                  Manage Session
                                </TableCell>
                                <TableCell >
                                  <FormControlLabel required control={<Checkbox color="success" />}
                                    label="View"
                                    color="success"
                                    name="permissions" onChange={handlechnage} value="104" control={<Checkbox checked={hasChecked(104)} />} />
                                  <FormControlLabel required control={<Checkbox />}
                                    label="Add"
                                    name="permissions" onChange={handlechnage} value="105" control={<Checkbox checked={hasChecked(105)} />} />
                                  <FormControlLabel required control={<Checkbox color="secondary" />}
                                    label="Edit"
                                    name="permissions" onChange={handlechnage} value="106" control={<Checkbox checked={hasChecked(106)} />} />
                                  <FormControlLabel required control={<Checkbox sx={{

                                    '&.Mui-checked': {
                                      color: pink[600],
                                    },
                                  }} />}
                                    label="Delete"
                                    name="permissions" onChange={handlechnage} value="107" control={<Checkbox checked={hasChecked(107)} />} />
                                </TableCell>
                              </TableRow>

                              <TableRow
                                key={4}
                                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                <TableCell component="th" scope="row">
                                  4
                                </TableCell>
                                <TableCell component="th" scope="row">
                                  Manage Participant
                                </TableCell>
                                <TableCell >
                                  <FormControlLabel required control={<Checkbox color="success" />}
                                    label="View"
                                    color="success"
                                    name="permissions" onChange={handlechnage} value="108" control={<Checkbox checked={hasChecked(108)} />} />
                                  <FormControlLabel required control={<Checkbox />}
                                    label="Add"
                                    name="permissions" onChange={handlechnage} value="109" control={<Checkbox checked={hasChecked(109)} />} />
                                  <FormControlLabel required control={<Checkbox color="secondary" />}
                                    label="Edit Workshop"
                                    name="permissions" onChange={handlechnage} value="110" checked={hasChecked(110)} />
                                  <FormControlLabel required control={<Checkbox color="success" />}
                                    label="Delete"
                                    color="success"
                                    name="permissions" onChange={handlechnage} value="111" control={<Checkbox checked={hasChecked(111)} />} />
                                  <FormControlLabel required control={<Checkbox color="success" />}
                                    label="Edit Basic Information"
                                    color="success"
                                    name="permissions" onChange={handlechnage} value="112" control={<Checkbox checked={hasChecked(112)} />} />

                                  <FormControlLabel required control={<Checkbox sx={{

                                    '&.Mui-checked': {
                                      color: pink[600],
                                    },
                                  }} />}
                                    label="Imort"
                                    name="permissions" onChange={handlechnage} value="113" checked={hasChecked(113)} />
                                </TableCell>
                              </TableRow>

                              <TableRow
                                key={5}
                                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                <TableCell component="th" scope="row">
                                  5
                                </TableCell>
                                <TableCell component="th" scope="row">
                                  Orders
                                </TableCell>
                                <TableCell >
                                  <FormControlLabel required control={<Checkbox color="success" />}
                                    label="View"
                                    color="success"
                                    name="permissions" onChange={handlechnage} value="114" checked={hasChecked(114)} />
                                  <FormControlLabel required control={<Checkbox />}
                                    label="Export/Download"
                                    name="permissions" onChange={handlechnage} value="115" checked={hasChecked(115)} />
                                  <FormControlLabel required control={<Checkbox color="secondary" />}
                                    label="Verification"
                                    name="permissions" onChange={handlechnage} value="116" checked={hasChecked(116)} />
                                  <FormControlLabel required control={<Checkbox sx={{

                                    '&.Mui-checked': {
                                      color: pink[600],
                                    },
                                  }} />}
                                    label="view Workshops Verifiction"
                                    name="permissions" onChange={handlechnage} value="117" checked={hasChecked(117)} />
                                </TableCell>
                              </TableRow>

                              <TableRow
                                key={6}
                                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                <TableCell component="th" scope="row">
                                  6
                                </TableCell>
                                <TableCell component="th" scope="row">
                                  Memeber Statistics
                                </TableCell>
                                <TableCell >
                                  <FormControlLabel required control={<Checkbox color="success" />}
                                    label="View"
                                    color="success"
                                    name="permissions" onChange={handlechnage} value="118" checked={hasChecked(118)} />
                                  <FormControlLabel required control={<Checkbox />}
                                    label="Add"
                                    name="permissions" onChange={handlechnage} value="119" checked={hasChecked(119)} />
                                  <FormControlLabel required control={<Checkbox color="secondary" />}
                                    label="Edit"
                                    name="permissions" onChange={handlechnage} value="120" checked={hasChecked(120)} />
                                  <FormControlLabel required control={<Checkbox sx={{

                                    '&.Mui-checked': {
                                      color: pink[600],
                                    },
                                  }} />}
                                    label="Delete"
                                    name="permissions" onChange={handlechnage} value="121" checked={hasChecked(121)} />
                                </TableCell>
                              </TableRow>

                              <TableRow
                                key={7}
                                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                <TableCell component="th" scope="row">
                                  7
                                </TableCell>
                                <TableCell component="th" scope="row">
                                  Invitations
                                </TableCell>
                                <TableCell >
                                  <FormControlLabel required control={<Checkbox color="success" />}
                                    label="View"
                                    color="success"
                                    name="permissions" onChange={handlechnage} value="122" checked={hasChecked(122)} />
                                  <FormControlLabel required control={<Checkbox />}
                                    label="Add"
                                    name="permissions" onChange={handlechnage} value="123" checked={hasChecked(123)} />
                                  <FormControlLabel required control={<Checkbox color="secondary" />}
                                    label="Edit"
                                    name="permissions" onChange={handlechnage} value="124" checked={hasChecked(124)} />
                                  <FormControlLabel required control={<Checkbox sx={{

                                    '&.Mui-checked': {
                                      color: pink[600],
                                    },
                                  }} />}
                                    label="Delete"
                                    name="permissions" onChange={handlechnage} value="125" checked={hasChecked(125)} />
                                </TableCell>
                              </TableRow>

                              {/* <TableRow
                                key={8}
                                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                <TableCell component="th" scope="row">
                                  8
                                </TableCell>
                                <TableCell component="th" scope="row">
                                 Export Participant
                                </TableCell>
                                <TableCell >
                                  <FormControlLabel required control={<Checkbox color="success" />}
                                    label="View"
                                    color="success"
                                    name="permissions" onChange={handlechnage} value="81" checked={hasChecked(81)} />
                                  <FormControlLabel required control={<Checkbox />}
                                    label="Add"
                                    name="permissions" onChange={handlechnage} value="82" checked={hasChecked(82)} />
                                  <FormControlLabel required control={<Checkbox color="secondary" />}
                                    label="Edit"
                                    name="permissions" onChange={handlechnage} value="83" checked={hasChecked(83)} />
                                  <FormControlLabel required control={<Checkbox sx={{

                                    '&.Mui-checked': {
                                      color: pink[600],
                                    },
                                  }} />}
                                    label="Delete"
                                    name="permissions" onChange={handlechnage} value="84" checked={hasChecked(84)} />
                                </TableCell>
                              </TableRow>

                              <TableRow
                                key={9}
                                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                <TableCell component="th" scope="row">
                                  9
                                </TableCell>
                                <TableCell component="th" scope="row">
                                 Import Participant
                                </TableCell>
                                <TableCell >
                                  <FormControlLabel required control={<Checkbox color="success" />}
                                    label="View"
                                    color="success"
                                    name="permissions" onChange={handlechnage} value="85" checked={hasChecked(85)} />
                                 
                                </TableCell>
                              </TableRow> */}

                              <TableRow
                                key={8}
                                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                <TableCell component="th" scope="row">
                                  8
                                </TableCell>
                                <TableCell component="th" scope="row">
                                  Coupons
                                </TableCell>
                                <TableCell >
                                  <FormControlLabel required control={<Checkbox color="success" />}
                                    label="View"
                                    color="success"
                                    name="permissions" onChange={handlechnage} value="126" checked={hasChecked(126)} />
                                  <FormControlLabel required control={<Checkbox color="secondary" />}
                                    label="Add"
                                    name="permissions" onChange={handlechnage} value="127" checked={hasChecked(127)} />


                                  <FormControlLabel required control={<Checkbox color="secondary" />}
                                    label="show"
                                    name="permissions" onChange={handlechnage} value="128" checked={hasChecked(128)} />
                                  <FormControlLabel required control={<Checkbox />}
                                    label="print"
                                    name="permissions" onChange={handlechnage} value="129" checked={hasChecked(129)} />
                                  <FormControlLabel required control={<Checkbox color="secondary" />}
                                    label="Send Email"
                                    name="permissions" onChange={handlechnage} value="130" checked={hasChecked(130)} />

                                  <FormControlLabel required control={<Checkbox sx={{

                                    '&.Mui-checked': {
                                      color: pink[600],
                                    },
                                  }} />}
                                    label="Export/Download"
                                    name="permissions" onChange={handlechnage} value="131" checked={hasChecked(131)} />
                                </TableCell>
                              </TableRow>
                              <TableRow
                                key={9}
                                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                <TableCell component="th" scope="row">
                                  9
                                </TableCell>
                                <TableCell component="th" scope="row">
                                  Event Certificate
                                </TableCell>
                                <TableCell >
                                  <FormControlLabel required control={<Checkbox color="success" />}
                                    label="View"
                                    color="success"
                                    name="permissions" onChange={handlechnage} value="132" checked={hasChecked(132)} />
                                  <FormControlLabel required control={<Checkbox />}
                                    label="Add"
                                    name="permissions" onChange={handlechnage} value="133" checked={hasChecked(133)} />
                                  <FormControlLabel required control={<Checkbox color="secondary" />}
                                    label="Edit"
                                    name="permissions" onChange={handlechnage} value="134" checked={hasChecked(134)} />
                                  <FormControlLabel required control={<Checkbox sx={{

                                    '&.Mui-checked': {
                                      color: pink[600],
                                    },
                                  }} />}
                                    label="Delete"
                                    name="permissions" onChange={handlechnage} value="135" checked={hasChecked(135)} />
                                </TableCell>
                              </TableRow>

                              <TableRow
                                key={12}
                                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                <TableCell component="th" scope="row">
                                  10
                                </TableCell>
                                <TableCell component="th" scope="row">
                                  Workhop User Manage
                                </TableCell>
                                <TableCell >
                                  <FormControlLabel required control={<Checkbox color="success" />}
                                    label="View"
                                    color="success"
                                    name="permissions" onChange={handlechnage} value="136" checked={hasChecked(136)} />
                                  <FormControlLabel required control={<Checkbox />}
                                    label="Add"
                                    name="permissions" onChange={handlechnage} value="137" checked={hasChecked(137)} />
                                  <FormControlLabel required control={<Checkbox color="secondary" />}
                                    label="Edit"
                                    name="permissions" onChange={handlechnage} value="138" checked={hasChecked(138)} />
                                  <FormControlLabel required control={<Checkbox sx={{

                                    '&.Mui-checked': {
                                      color: pink[600],
                                    },
                                  }} />}
                                    label="Delete"
                                    name="permissions" onChange={handlechnage} value="139" checked={hasChecked(139)} />
                                </TableCell>
                              </TableRow>
                              {/* 140 used for  Manage Workshop  url copy line no 1207 */}
                              {/* 140 used for  Manage Workshop  url copy line no 1207 */}
                              <TableRow
                                key={13}
                                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                <TableCell component="th" scope="row">
                                  11
                                </TableCell>
                                <TableCell component="th" scope="row">
                                  Download Workshop Attendance
                                </TableCell>
                                <TableCell >
                                  <FormControlLabel required control={<Checkbox color="success" />}
                                    label="Export/Download"
                                    color="success"
                                    name="permissions" onChange={handlechnage} value="141" checked={hasChecked(141)} />

                                </TableCell>


                              </TableRow>


                              <TableRow
                                key={14}
                                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                <TableCell component="th" scope="row">
                                  12
                                </TableCell>
                                <TableCell component="th" scope="row">
                                  Workshop Collections
                                </TableCell>
                                <TableCell >
                                  <FormControlLabel required control={<Checkbox color="success" />}
                                    label="View"
                                    color="success"
                                    name="permissions" onChange={handlechnage} value="142" checked={hasChecked(142)} />

                                </TableCell>


                              </TableRow>





                            </TableBody>
                          </Table>
                        </TabPanel>}
                        {value === 4 && <TabPanel>
                          {/* Conference permissions */}

                          <Table size="small" aria-label="a dense table">
                            <TableHead>
                              <TableRow sx={{ color: '#FFFFFF' }}>
                                <TableCell >#</TableCell>
                                <TableCell style={{ width: "20%", height: 100 }}> Module Name</TableCell>
                                <TableCell style={{ width: "60%", height: 100 }}>Permissions</TableCell>
                              </TableRow>
                            </TableHead>
                            <TableHead>
                            </TableHead>
                            <TableBody>
                              <TableRow
                                key={1}
                                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                <TableCell component="th" scope="row">
                                  1
                                </TableCell>
                                <TableCell component="th" scope="row">
                                  Conference Collections
                                </TableCell>
                                <TableCell >
                                  <FormControlLabel required control={<Checkbox color="success" />}
                                    label="View"
                                    color="success"
                                    name="permissions" onChange={handlechnage} value="143" control={<Checkbox checked={hasChecked(143)} />} />
                                </TableCell>
                              </TableRow>
                              <TableRow
                                key={2}
                                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                <TableCell component="th" scope="row">
                                  2
                                </TableCell>
                                <TableCell component="th" scope="row">
                                  Conference Categories
                                </TableCell>
                                <TableCell >
                                  <FormControlLabel required control={<Checkbox color="success" />}
                                    label="View"
                                    color="success"
                                    name="permissions" onChange={handlechnage} value="144" control={<Checkbox checked={hasChecked(144)} />} />
                                  <FormControlLabel required control={<Checkbox />}
                                    label="Add"
                                    name="permissions" onChange={handlechnage} value="145" control={<Checkbox checked={hasChecked(145)} />} />
                                  <FormControlLabel required control={<Checkbox color="secondary" />}
                                    label="Edit"
                                    name="permissions" onChange={handlechnage} value="146" control={<Checkbox checked={hasChecked(146)} />} />
                                  <FormControlLabel required control={<Checkbox
                                    sx={{
                                      '&.Mui-checked': {
                                        color: pink[600],
                                      },
                                    }} />}
                                    label="Delete"
                                    name="permissions" onChange={handlechnage} value="147" control={<Checkbox checked={hasChecked(147)} />} />
                                </TableCell>
                              </TableRow>

                              <TableRow
                                key={3}
                                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                <TableCell component="th" scope="row">
                                  3
                                </TableCell>
                                <TableCell component="th" scope="row">
                                  Manage Conference
                                </TableCell>
                                <TableCell >
                                  <FormControlLabel required control={<Checkbox color="success" />}
                                    label="View"
                                    color="success"
                                    name="permissions" onChange={handlechnage} value="148" control={<Checkbox checked={hasChecked(148)} />} />
                                  <FormControlLabel required control={<Checkbox />}
                                    label="Add"
                                    name="permissions" onChange={handlechnage} value="149" control={<Checkbox checked={hasChecked(149)} />} />
                                  <FormControlLabel required control={<Checkbox color="secondary" />}
                                    label="Edit"
                                    name="permissions" onChange={handlechnage} value="150" control={<Checkbox checked={hasChecked(150)} />} />

                                  <FormControlLabel required control={<Checkbox color="secondary" />}
                                    label="Conference URL"
                                    name="permissions" onChange={handlechnage} value="188" control={<Checkbox checked={hasChecked(188)} />} />

                                  <FormControlLabel required control={<Checkbox sx={{

                                    '&.Mui-checked': {
                                      color: pink[600],
                                    },
                                  }} />}
                                    label="Delete"
                                    name="permissions" onChange={handlechnage} value="151" control={<Checkbox checked={hasChecked(151)} />} />
                                </TableCell>
                              </TableRow>

                              <TableRow
                                key={4}
                                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>

                                <TableCell component="th" scope="row">
                                  4
                                </TableCell>
                                <TableCell component="th" scope="row">
                                  Manage Session
                                </TableCell>
                                <TableCell >
                                  <FormControlLabel required control={<Checkbox color="success" />}
                                    label="View"
                                    color="success"
                                    name="permissions" onChange={handlechnage} value="152" control={<Checkbox checked={hasChecked(152)} />} />
                                  <FormControlLabel required control={<Checkbox />}
                                    label="Add"
                                    name="permissions" onChange={handlechnage} value="153" control={<Checkbox checked={hasChecked(153)} />} />
                                  <FormControlLabel required control={<Checkbox color="secondary" />}
                                    label="Edit"
                                    name="permissions" onChange={handlechnage} value="154" control={<Checkbox checked={hasChecked(154)} />} />
                                  <FormControlLabel required control={<Checkbox sx={{

                                    '&.Mui-checked': {
                                      color: pink[600],
                                    },
                                  }} />}
                                    label="Delete"
                                    name="permissions" onChange={handlechnage} value="155" control={<Checkbox checked={hasChecked(155)} />} />
                                </TableCell>
                              </TableRow>

                              <TableRow
                                key={5}
                                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                <TableCell component="th" scope="row">
                                  5
                                </TableCell>
                                <TableCell component="th" scope="row">
                                  Manage Participant
                                </TableCell>
                                <TableCell >
                                  <FormControlLabel required control={<Checkbox color="success" />}
                                    label="View"
                                    color="success"
                                    name="permissions" onChange={handlechnage} value="156" control={<Checkbox checked={hasChecked(156)} />} />
                                  <FormControlLabel required control={<Checkbox />}
                                    label="Add"
                                    name="permissions" onChange={handlechnage} value="157" control={<Checkbox checked={hasChecked(157)} />} />
                                  <FormControlLabel required control={<Checkbox color="secondary" />}
                                    label="Edit Conference"
                                    name="permissions" onChange={handlechnage} value="158" checked={hasChecked(158)} />
                                  <FormControlLabel required control={<Checkbox color="success" />}
                                    label="Delete"
                                    color="success"
                                    name="permissions" onChange={handlechnage} value="159" control={<Checkbox checked={hasChecked(159)} />} />
                                  <FormControlLabel required control={<Checkbox color="success" />}
                                    label="Edit Basic Information"
                                    color="success"
                                    name="permissions" onChange={handlechnage} value="160" control={<Checkbox checked={hasChecked(160)} />} />

                                  <FormControlLabel required control={<Checkbox sx={{

                                    '&.Mui-checked': {
                                      color: pink[600],
                                    },
                                  }} />}
                                    label="Imort"
                                    name="permissions" onChange={handlechnage} value="161" checked={hasChecked(161)} />
                                </TableCell>
                              </TableRow>

                              <TableRow
                                key={6}
                                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                <TableCell component="th" scope="row">
                                  6
                                </TableCell>
                                <TableCell component="th" scope="row">
                                  Orders
                                </TableCell>
                                <TableCell >
                                  <FormControlLabel required control={<Checkbox color="success" />}
                                    label="View"
                                    color="success"
                                    name="permissions" onChange={handlechnage} value="162" checked={hasChecked(162)} />
                                  <FormControlLabel required control={<Checkbox />}
                                    label="Export/Download"
                                    name="permissions" onChange={handlechnage} value="163" checked={hasChecked(163)} />
                                  <FormControlLabel required control={<Checkbox color="secondary" />}
                                    label="Verification"
                                    name="permissions" onChange={handlechnage} value="164" checked={hasChecked(164)} />
                                  <FormControlLabel required control={<Checkbox sx={{

                                    '&.Mui-checked': {
                                      color: pink[600],
                                    },
                                  }} />}
                                    label="view Conference Verifiction"
                                    name="permissions" onChange={handlechnage} value="165" checked={hasChecked(165)} />
                                </TableCell>
                              </TableRow>

                              <TableRow
                                key={7}
                                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                <TableCell component="th" scope="row">
                                  7
                                </TableCell>
                                <TableCell component="th" scope="row">
                                  Memeber Statistics
                                </TableCell>
                                <TableCell >
                                  <FormControlLabel required control={<Checkbox color="success" />}
                                    label="View"
                                    color="success"
                                    name="permissions" onChange={handlechnage} value="166" checked={hasChecked(166)} />
                                  <FormControlLabel required control={<Checkbox />}
                                    label="Add"
                                    name="permissions" onChange={handlechnage} value="167" checked={hasChecked(167)} />
                                  <FormControlLabel required control={<Checkbox color="secondary" />}
                                    label="Edit"
                                    name="permissions" onChange={handlechnage} value="168" checked={hasChecked(168)} />
                                  <FormControlLabel required control={<Checkbox sx={{

                                    '&.Mui-checked': {
                                      color: pink[600],
                                    },
                                  }} />}
                                    label="Delete"
                                    name="permissions" onChange={handlechnage} value="169" checked={hasChecked(169)} />
                                </TableCell>
                              </TableRow>

                              <TableRow
                                key={8}
                                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                <TableCell component="th" scope="row">
                                  8
                                </TableCell>
                                <TableCell component="th" scope="row">
                                  Invitations
                                </TableCell>
                                <TableCell >
                                  <FormControlLabel required control={<Checkbox color="success" />}
                                    label="View"
                                    color="success"
                                    name="permissions" onChange={handlechnage} value="170" checked={hasChecked(170)} />
                                  <FormControlLabel required control={<Checkbox />}
                                    label="Add"
                                    name="permissions" onChange={handlechnage} value="171" checked={hasChecked(171)} />
                                  <FormControlLabel required control={<Checkbox color="secondary" />}
                                    label="Edit"
                                    name="permissions" onChange={handlechnage} value="172" checked={hasChecked(172)} />
                                  <FormControlLabel required control={<Checkbox sx={{

                                    '&.Mui-checked': {
                                      color: pink[600],
                                    },
                                  }} />}
                                    label="Delete"
                                    name="permissions" onChange={handlechnage} value="173" checked={hasChecked(173)} />
                                </TableCell>
                              </TableRow>

                              <TableRow
                                key={9}
                                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                <TableCell component="th" scope="row">
                                  9
                                </TableCell>
                                <TableCell component="th" scope="row">
                                  Coupons
                                </TableCell>
                                <TableCell >
                                  <FormControlLabel required control={<Checkbox color="success" />}
                                    label="View"
                                    color="success"
                                    name="permissions" onChange={handlechnage} value="174" checked={hasChecked(174)} />
                                  <FormControlLabel required control={<Checkbox color="secondary" />}
                                    label="Add"
                                    name="permissions" onChange={handlechnage} value="175" checked={hasChecked(175)} />


                                  <FormControlLabel required control={<Checkbox color="secondary" />}
                                    label="show"
                                    name="permissions" onChange={handlechnage} value="176" checked={hasChecked(176)} />
                                  <FormControlLabel required control={<Checkbox />}
                                    label="print"
                                    name="permissions" onChange={handlechnage} value="177" checked={hasChecked(177)} />
                                  <FormControlLabel required control={<Checkbox color="secondary" />}
                                    label="Send Email"
                                    name="permissions" onChange={handlechnage} value="178" checked={hasChecked(178)} />

                                  <FormControlLabel required control={<Checkbox sx={{

                                    '&.Mui-checked': {
                                      color: pink[600],
                                    },
                                  }} />}
                                    label="Export/Download"
                                    name="permissions" onChange={handlechnage} value="179" checked={hasChecked(179)} />
                                </TableCell>
                              </TableRow>
                              <TableRow
                                key={10}
                                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                <TableCell component="th" scope="row">
                                  10
                                </TableCell>
                                <TableCell component="th" scope="row">
                                  Event Certificate
                                </TableCell>
                                <TableCell >
                                  <FormControlLabel required control={<Checkbox color="success" />}
                                    label="View"
                                    color="success"
                                    name="permissions" onChange={handlechnage} value="180" checked={hasChecked(180)} />
                                  <FormControlLabel required control={<Checkbox />}
                                    label="Add"
                                    name="permissions" onChange={handlechnage} value="181" checked={hasChecked(181)} />
                                  <FormControlLabel required control={<Checkbox color="secondary" />}
                                    label="Edit"
                                    name="permissions" onChange={handlechnage} value="182" checked={hasChecked(182)} />
                                  <FormControlLabel required control={<Checkbox sx={{

                                    '&.Mui-checked': {
                                      color: pink[600],
                                    },
                                  }} />}
                                    label="Delete"
                                    name="permissions" onChange={handlechnage} value="183" checked={hasChecked(183)} />
                                </TableCell>
                              </TableRow>

                              <TableRow
                                key={11}
                                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                <TableCell component="th" scope="row">
                                  11
                                </TableCell>
                                <TableCell component="th" scope="row">
                                  Conference User Manage
                                </TableCell>
                                <TableCell >
                                  <FormControlLabel required control={<Checkbox color="success" />}
                                    label="View"
                                    color="success"
                                    name="permissions" onChange={handlechnage} value="184" checked={hasChecked(184)} />
                                  <FormControlLabel required control={<Checkbox />}
                                    label="Add"
                                    name="permissions" onChange={handlechnage} value="185" checked={hasChecked(185)} />
                                  <FormControlLabel required control={<Checkbox color="secondary" />}
                                    label="Edit"
                                    name="permissions" onChange={handlechnage} value="186" checked={hasChecked(186)} />
                                  <FormControlLabel required control={<Checkbox sx={{

                                    '&.Mui-checked': {
                                      color: pink[600],
                                    },
                                  }} />}
                                    label="Delete"
                                    name="permissions" onChange={handlechnage} value="187" checked={hasChecked(187)} />
                                </TableCell>
                              </TableRow>
                              {/* 188 use for conference attendce url line number 1670 */}
                              <TableRow
                                key={12}
                                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                <TableCell component="th" scope="row">
                                  12
                                </TableCell>
                                <TableCell component="th" scope="row">
                                  Download Conference Attendance
                                </TableCell>
                                <TableCell >
                                  <FormControlLabel required control={<Checkbox color="success" />}
                                    label="Export/Download"
                                    color="success"
                                    name="permissions" onChange={handlechnage} value="189" checked={hasChecked(189)} />

                                </TableCell>
                              </TableRow>

                              <TableRow
                                key={13}
                                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                <TableCell component="th" scope="row">
                                  13
                                </TableCell>
                                <TableCell component="th" scope="row">
                                  Conference Report
                                </TableCell>
                                <TableCell >
                                  <FormControlLabel required control={<Checkbox color="success" />}
                                    label="View"
                                    color="success"
                                    name="permissions" onChange={handlechnage} value="190" checked={hasChecked(190)} />


                                  <FormControlLabel required control={<Checkbox color="success" />}
                                    label="Download"
                                    color="success"
                                    name="permissions" onChange={handlechnage} value="191" checked={hasChecked(191)} />

                                </TableCell>
                              </TableRow>
                              {/* 192 used for conference email template url copy line no 330 */}
                              <TableRow
                                key={14}
                                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                <TableCell component="th" scope="row">
                                  14
                                </TableCell>
                                <TableCell component="th" scope="row">
                                  Conference Badge
                                </TableCell>
                                <TableCell >
                                  <FormControlLabel required control={<Checkbox color="success" />}
                                    label="View"
                                    color="success"
                                    name="permissions" onChange={handlechnage} value="193" checked={hasChecked(193)} />
                                </TableCell>
                              </TableRow>
                              {/* 194 used for c Abstract Score line no 814 */}

                             


                            </TableBody>
                          </Table>
                        </TabPanel>}
                        {value === 5 && <TabPanel>
                          <Table sx={{ minWidth: 650 }} aria-label="simple table">
                            <TableHead>
                              <TableRow>
                                <TableCell>Sr No</TableCell>
                                <TableCell align="left">Permission Name</TableCell>
                                <TableCell align="left">Action</TableCell>
                              </TableRow>
                            </TableHead>
                            <TableBody>
                              <TableRow
                                key={1}
                                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                <TableCell component="th" scope="row">
                                  1
                                </TableCell>
                                <TableCell component="th" scope="row">
                                Conference Affiliation Dashboard
                                </TableCell>
                                <TableCell >
                                  <FormControlLabel required control={<Checkbox color="success" />}
                                    label="View"
                                    color="success"
                                    name="permissions" onChange={handlechnage} value="195" control={<Checkbox checked={hasChecked(195)} />} />
                                </TableCell>
                              </TableRow>
                              <TableRow
                                key={2}
                                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                <TableCell component="th" scope="row">
                                  2
                                </TableCell>
                                <TableCell component="th" scope="row">
                                  Conference Affiliation Badge
                                </TableCell>
                                <TableCell >
                                  <FormControlLabel required control={<Checkbox color="success" />}
                                    label="View"
                                    color="success"
                                    name="permissions" onChange={handlechnage} value="196" control={<Checkbox checked={hasChecked(196)} />} />
                                </TableCell>
                              </TableRow>
                              <TableRow
                                key={3}
                                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                <TableCell component="th" scope="row">
                                  3
                                </TableCell>
                                <TableCell component="th" scope="row">
                                  Conference Affiliation Registration Report
                                </TableCell>
                                <TableCell >
                                  <FormControlLabel required control={<Checkbox color="success" />}
                                    label="View"
                                    color="success"
                                    name="permissions" onChange={handlechnage} value="197" control={<Checkbox checked={hasChecked(197)} />} />
                                </TableCell>
                              </TableRow>
                              <TableRow
                                key={4}
                                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                <TableCell component="th" scope="row">
                                  4
                                </TableCell>
                                <TableCell component="th" scope="row">
                                  Conference Affiliation Attendance Report
                                </TableCell>
                                <TableCell >
                                  <FormControlLabel required control={<Checkbox color="success" />}
                                    label="View"
                                    color="success"
                                    name="permissions" onChange={handlechnage} value="198" control={<Checkbox checked={hasChecked(198)} />} />
                                </TableCell>
                              </TableRow>
                              <TableRow
                                key={5}
                                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                <TableCell component="th" scope="row">
                                  5
                                </TableCell>
                                <TableCell component="th" scope="row">
                                  Conference Affiliation Participant Count Report
                                </TableCell>
                                <TableCell >
                                  <FormControlLabel required control={<Checkbox color="success" />}
                                    label="View"
                                    color="success"
                                    name="permissions" onChange={handlechnage} value="199" control={<Checkbox checked={hasChecked(199)} />} />
                                </TableCell>
                              </TableRow>
                              <TableRow
                                key={6}
                                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                <TableCell component="th" scope="row">
                                  6
                                </TableCell>
                                <TableCell component="th" scope="row">
                                  Conference Affiliation Collections
                                </TableCell>
                                <TableCell >
                                  <FormControlLabel required control={<Checkbox color="success" />}
                                    label="View"
                                    color="success"
                                    name="permissions" onChange={handlechnage} value="200" control={<Checkbox checked={hasChecked(200)} />} />
                                </TableCell>
                              </TableRow> 


                            </TableBody>
                          </Table>

                          </TabPanel>}
                        {value === 6 && <TabPanel>MMS permissions</TabPanel>}
                        {value === 7 && <TabPanel>Content for Tab 5</TabPanel>}
                      </div>

                    </TableContainer>
                  </CardContent>
                </Card>
              </Box>

              <Grid container justifyContent="flex-end">
                <Button
                  type="submit"
                  variant="contained"
                  sx={{ mt: 3, mb: 2 }}
                >
                  Add Role
                </Button>
              </Grid>
            </Box>
          </CardContent>
        </Card>
      </Box>
    </div>
  );
}

export default Permissions;
